var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.232,
    height: 21.217,
    viewBox: "0 0 27.232 21.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.054,
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3505",
    "data-name": "Groupe 3505",
    transform: "translate(-13170.539 3698.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M28707.7,20669.918a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,28707.7,20669.918Zm10.863.057v-4.289a8.578,8.578,0,0,0-6.459-8.506,8.483,8.483,0,0,0-7.145,1.637,8.321,8.321,0,0,0-3.127,6.51v4.648a2.376,2.376,0,0,1-4.752,0v-4.648a13.14,13.14,0,0,1,16.039-12.773,13.334,13.334,0,0,1,10.193,13.133v4.289a2.375,2.375,0,0,1-4.75,0Z",
    transform: "translate(-15526.039 -24350.17)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconColor);
export default __webpack_public_path__ + "static/media/mediaIconColor.2e81b41b3d70e68cea836469b34d4bb6.svg";
export { ForwardRef as ReactComponent };